var _style, _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoHistorial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.72 34.63",
    style: {
      enableBackground: "new 0 0 32.72 34.63"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000010279863890036719300000005233741805685902225_);}\n\t.st1{fill:#7367F0;}\n\t.st2{fill:none;stroke:#7367F0;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2154",
    transform: "translate(-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2181",
    transform: "translate(6)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 32.73,
    height: 34.66
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052068949003696724460000008049373137017553331_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2154-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3596",
    className: "st1",
    d: "M32.51,15.55C31.02,6.62,22.57,0.58,13.64,2.07c-2.13,0.35-4.16,1.12-5.99,2.26L7.07,4.7 l0.94-2.56c0.3-0.81-0.11-1.72-0.93-2.02S5.36,0.24,5.06,1.05L2.53,7.92c0,0.01-0.01,0.03-0.01,0.04 C2.5,7.99,2.5,8.02,2.49,8.05C2.48,8.09,2.47,8.13,2.46,8.17C2.46,8.2,2.45,8.23,2.45,8.25c0,0.01-0.01,0.03-0.01,0.04v0.01 c0,0.02,0,0.04,0,0.05c0,0.04,0,0.07,0,0.11s0,0.07,0,0.11s0.01,0.06,0.01,0.08s0.01,0.07,0.02,0.11s0.01,0.07,0.02,0.1 s0.02,0.06,0.03,0.09s0.02,0.06,0.04,0.1S2.58,9.13,2.6,9.16s0.03,0.06,0.05,0.08c0.01,0.02,0.02,0.03,0.03,0.05 C2.68,9.31,2.69,9.32,2.7,9.34c0.02,0.03,0.04,0.05,0.05,0.07S2.81,9.47,2.83,9.5S2.87,9.55,2.9,9.57s0.05,0.04,0.07,0.06 S3.02,9.68,3.05,9.7s0.06,0.04,0.09,0.06S3.19,9.8,3.21,9.81s0.06,0.03,0.1,0.05S3.37,9.9,3.41,9.91 c0.03,0.02,0.07,0.03,0.1,0.04c0.03,0.01,0.05,0.02,0.08,0.02h0.01C3.62,9.98,3.65,9.99,3.69,10s0.07,0.01,0.1,0.02 c0.02,0.01,0.04,0.01,0.06,0.01l7.28,0.74c0.05,0.01,0.11,0.01,0.16,0.01c0.87,0.01,1.58-0.69,1.58-1.56 c0-0.81-0.61-1.5-1.42-1.57L8.73,7.36L9.31,7c6.21-3.88,14.39-1.98,18.27,4.23s1.98,14.39-4.23,18.27 c-6.21,3.88-14.4,1.98-18.27-4.23c-1.07-1.71-1.73-3.65-1.94-5.65c-0.07-0.86-0.83-1.51-1.7-1.43s-1.51,0.83-1.43,1.7 c0,0.02,0,0.03,0,0.05c0.72,6.97,5.79,12.72,12.62,14.3c8.82,2.04,17.63-3.45,19.68-12.28c0,0,0,0,0,0l0.02-0.1l0,0 C32.8,19.78,32.86,17.64,32.51,15.55"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3597",
    className: "st2",
    d: "M16.37,10.5v8.17l5.44,2.72"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoHistorial);
export default __webpack_public_path__ + "static/media/icono-historial.f5947db7074bce65f476808ab221a5ea.svg";
export { ForwardRef as ReactComponent };